var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-popup',{attrs:{"title":_vm.$t('image_preview'),"active":_vm.popupActive},on:{"update:active":function($event){_vm.popupActive=$event}}},[(_vm.selectImage)?_c('img',{staticClass:"resp_img",attrs:{"src":_vm.selectImage.path,"alt":_vm.selectImage.name}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }